import { Entity } from '../index.js';
import { getContactPerson } from '../customers/index.js';
import { assertUnreachable } from '../util/index.js';
import { EBoksRecipientType, } from './eboks.js';
export var IncomingState;
(function (IncomingState) {
    IncomingState["UNMAPPED"] = "UNMAPPED";
    IncomingState["MAPPED"] = "MAPPED";
    IncomingState["HANDLED"] = "HANDLED";
    IncomingState["DELETED"] = "DELETED";
})(IncomingState || (IncomingState = {}));
export var OutgoingState;
(function (OutgoingState) {
    OutgoingState["PENDING"] = "PENDING";
    OutgoingState["QUEUED"] = "QUEUED";
    OutgoingState["SENT"] = "SENT";
    OutgoingState["CANCELLED"] = "CANCELLED";
})(OutgoingState || (OutgoingState = {}));
export var InteractionType;
(function (InteractionType) {
    InteractionType["Eboks"] = "EBOKS";
    InteractionType["Kivra"] = "KIVRA";
    InteractionType["Digipost"] = "DIGIPOST";
    InteractionType["Email"] = "EMAIL";
    InteractionType["SMS"] = "SMS";
    InteractionType["Letter"] = "LETTER";
    InteractionType["Phone"] = "PHONE";
    InteractionType["Note"] = "NOTE";
    InteractionType["Personal"] = "PERSONAL";
    InteractionType["Other"] = "OTHER";
    InteractionType["ClientNote"] = "CLIENT NOTE";
    InteractionType["DebtorNote"] = "DEBTOR NOTE";
    InteractionType["AutoCall"] = "AUTO CALL";
    InteractionType["EInvoice"] = "EINVOICE";
})(InteractionType || (InteractionType = {}));
export var Direction;
(function (Direction) {
    Direction["OUTGOING"] = "OUTGOING";
    Direction["INCOMING"] = "INCOMING";
})(Direction || (Direction = {}));
export var ReturnReason;
(function (ReturnReason) {
    ReturnReason["UNKNOWNRECIPIENT"] = "UNKNOWNRECIPIENT";
    ReturnReason["NOTDELIVERABLE"] = "NOTDELIVERABLE";
    ReturnReason["DENIED"] = "DENIED";
})(ReturnReason || (ReturnReason = {}));
export var PhoneOutgoingTag;
(function (PhoneOutgoingTag) {
    PhoneOutgoingTag["NoAnswer"] = "NO_ANSWER";
    PhoneOutgoingTag["PaymentPlan"] = "PAYMENT_PLAN";
    PhoneOutgoingTag["OtherAgreement"] = "OTHER_AGREEMENT";
    PhoneOutgoingTag["IncorrectNumber"] = "INCORRECT_NUMBER";
    PhoneOutgoingTag["WrongNumber"] = "WRONG_NUMBER";
    PhoneOutgoingTag["FullPayment"] = "FULL_PAYMENT";
    PhoneOutgoingTag["Opposition"] = "OPPOSITION";
    PhoneOutgoingTag["Other"] = "OTHER";
})(PhoneOutgoingTag || (PhoneOutgoingTag = {}));
export var PhoneIncomingTag;
(function (PhoneIncomingTag) {
    PhoneIncomingTag["PaymentPlan"] = "PAYMENT_PLAN";
    PhoneIncomingTag["OtherAgreement"] = "OTHER_AGREEMENT";
    PhoneIncomingTag["FullPayment"] = "FULL_PAYMENT";
    PhoneIncomingTag["Opposition"] = "OPPOSITION";
    PhoneIncomingTag["Other"] = "OTHER";
    PhoneIncomingTag["Billing"] = "BILLING";
    PhoneIncomingTag["Terms"] = "TERMS";
    PhoneIncomingTag["Caseworking"] = "CASEWORKING";
})(PhoneIncomingTag || (PhoneIncomingTag = {}));
export const EntityPhoneTags = {
    [Entity.Case]: [
        PhoneOutgoingTag.NoAnswer,
        PhoneOutgoingTag.PaymentPlan,
        PhoneOutgoingTag.OtherAgreement,
        PhoneOutgoingTag.IncorrectNumber,
        PhoneOutgoingTag.WrongNumber,
        PhoneOutgoingTag.FullPayment,
        PhoneOutgoingTag.Opposition,
        PhoneOutgoingTag.Other,
        PhoneIncomingTag.PaymentPlan,
        PhoneIncomingTag.OtherAgreement,
        PhoneIncomingTag.FullPayment,
        PhoneIncomingTag.Opposition,
        PhoneIncomingTag.Other,
    ],
    [Entity.Creditor]: [
        PhoneIncomingTag.Other,
        PhoneIncomingTag.Billing,
        PhoneIncomingTag.Terms,
        PhoneIncomingTag.Caseworking,
    ],
};
export var InteractionEventType;
(function (InteractionEventType) {
    InteractionEventType["Sent"] = "SENT";
    InteractionEventType["Created"] = "CREATED";
})(InteractionEventType || (InteractionEventType = {}));
export var SandboxInteractionType;
(function (SandboxInteractionType) {
    SandboxInteractionType["Phone"] = "PHONE";
    SandboxInteractionType["SMS"] = "SMS";
    SandboxInteractionType["Note"] = "NOTE";
    SandboxInteractionType["ClientNote"] = "CLIENT NOTE";
    SandboxInteractionType["Letter"] = "LETTER";
    SandboxInteractionType["Email"] = "EMAIL";
})(SandboxInteractionType || (SandboxInteractionType = {}));
export const autoCallLookupFormat = (from, to) => `from:${from},to:${to}`;
export const genRecipientsRaw = (customer, options) => {
    const recipients = [];
    const contactPerson = getContactPerson(customer);
    const centralRegisterId = customer.isCompany
        ? contactPerson?.details.cvr
        : contactPerson?.details.cpr;
    if (centralRegisterId != null && centralRegisterId != '') {
        recipients.push({
            type: EBoksRecipientType.CentralRegisterId,
            centralRegisterId,
            isCompany: customer.isCompany,
        });
    }
    const names = !customer.isCompany
        ? contactPerson?.details.name?.split(' ')
        : null;
    const address = contactPerson?.details.address;
    if (names != null && address != null) {
        const KVHX = options.KVHX;
        if (KVHX != null) {
            recipients.push({
                type: EBoksRecipientType.KVHX,
                firstName: names.slice(0, -1).join(' '),
                lastName: names[names.length - 1],
                kvhx: KVHX,
            });
        }
    }
    return recipients;
};
export const findRecipient = (recipients, customer) => {
    const contactPerson = getContactPerson(customer);
    if (contactPerson?.details.deliverability?.eboks &&
        contactPerson.details.deliverability.eboks.length > 0) {
        const priorAttempts = contactPerson.details.deliverability.eboks
            .map((x) => x)
            .reverse();
        for (const recipient of recipients) {
            const match = priorAttempts.find((x) => isSameRecipient(x.recipient, recipient));
            if (match != null) {
                if (!match.success) {
                    continue;
                }
            }
            return recipient;
        }
        return null;
    }
    return recipients[0] ?? null;
};
export const isSameRecipient = (a, b) => {
    if (a.type != b.type) {
        return false;
    }
    switch (a.type) {
        case EBoksRecipientType.KVHX: {
            const s = b;
            return (a.firstName === s.firstName &&
                a.lastName === s.lastName &&
                a.kvhx === s.kvhx);
        }
        case EBoksRecipientType.CentralRegisterId: {
            const s = b;
            return (a.isCompany === s.isCompany &&
                a.centralRegisterId === s.centralRegisterId);
        }
    }
    assertUnreachable(a);
};
//# sourceMappingURL=index.js.map